export const createPricingPlans = (t) => [
  {
    id: "free",
    name: t("PRICING_PLAN_FREE_NAME"),
    description: t("PRICING_PLAN_FREE_DESCRIPTION"),
    badge: t("PRICING_PLAN_FREE_BADGE"),
    features: [
      t("PRICING_PLAN_FREE_FEATURE_BOOKS"),
      t("PRICING_PLAN_FREE_FEATURE_AUDIO"),
      t("PRICING_PLAN_FREE_FEATURE_DICTIONARY"),
      t("PRICING_PLAN_FREE_FEATURE_SYNC"),
      t("PRICING_PLAN_FREE_FEATURE_CUSTOMIZATION"),
    ],
    price: t("PRICING_PLAN_FREE_PRICE"),
    note: t("PRICING_PLAN_FREE_NOTE"),
    buttonText: t("PRICING_PLAN_FREE_CTA"),
    buttonVariant: "primary",
    highlight: "primary",
  },
  {
    id: "premium",
    name: t("PRICING_PLAN_PREMIUM_NAME"),
    description: t("PRICING_PLAN_PREMIUM_DESCRIPTION"),
    badge: t("PRICING_PLAN_PREMIUM_BADGE"),
    features: [
      t("PRICING_PLAN_PREMIUM_FEATURE_LIBRARY"),
      t("PRICING_PLAN_PREMIUM_FEATURE_SPEED"),
      t("PRICING_PLAN_PREMIUM_FEATURE_HIGHLIGHT"),
      t("PRICING_PLAN_PREMIUM_FEATURE_FONOLOGY"),
      t("PRICING_PLAN_PREMIUM_FEATURE_STATS"),
      t("PRICING_PLAN_PREMIUM_FEATURE_COLLECTIONS"),      
    ],
    price: t("PRICING_PLAN_PREMIUM_PRICE"),
    period: t("PRICING_PLAN_PREMIUM_PERIOD"),
    note: t("PRICING_PLAN_PREMIUM_NOTE"),
    buttonText: t("PRICING_PLAN_PREMIUM_CTA"),
    buttonVariant: "success",
    highlight: "success",
  },
];

export default createPricingPlans;
